import { createAsyncThunk } from "@reduxjs/toolkit"
import { getRequest } from "../utils/GetRequest"
import { RootState } from "../../root-redux/RootState"
import { ENV_PROD } from "../../feature-components/spa-admin/SPAConstants"

export const getTaxonomy = createAsyncThunk<any, void, { state: RootState }>('taxonomy/getTaxonomy', async (_, {getState, rejectWithValue}) => {
    const env = getState().env.selectedEnvItem;
    const response = await getRequest<any>(`${env}/taxonomy`,env);
    const data = response.data;
    if ((data["Code"] || "").startsWith('ERR')) {
        return rejectWithValue({ message: "Unable to fetch Taxonomy information: " + JSON.stringify(data) });
    }
    return response.data;
})